// @flow
import * as React from 'react'
import { Container, Header, Month } from './elements'
import { getDateVariants, getDateFromDateValue } from '../utils'
import MonthRow from '../MonthRow'

// Types
export type Props = {
  value?: any,
  minDate?: Date,
  maxDate?: Date,
  onChange?: Function,
}
type State = {
  options: Array<any>,
}

/**
 * DatePicker componentn that shows all months as a list.
 * Call given `onChange` with Date object of selected date when
 * user click on some date which is not in the past.
 * @return {Component}
 */
class ScrollableCalendar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const { value, minDate, maxDate } = props
    this.state = { options: getDateVariants(value, minDate, maxDate) }
  }

  handleChangeDate = (selectedDate: any) => {
    const { onChange, value } = this.props
    const newDate = getDateFromDateValue(value, selectedDate)
    onChange && onChange(newDate)
  }

  render() {
    const { value } = this.props
    const { options } = this.state

    return (
      <Container>
        {options.map((month, i) => (
          <Month key={i}>
            <Header>{month.name}</Header>
            <MonthRow
              month={month}
              value={value}
              onChange={this.handleChangeDate}
            />
          </Month>
        ))}
      </Container>
    )
  }
}

export default ScrollableCalendar
